/**
 * Initialize all common UI and shared settings and resources for the panama web environment
 */
mmf_modules.define('initialize',[
    'jquery',
    'plugins/ui',
    'plugins/qtip',
    'plugins/cookies',
    'plugins/inlineEdit',
    'plugins/placeholder',
    'plugins/jquery.migrate',
    'plugins/mmf_polyfill',
    'app/tos/index',
    'app/navigation/index',
    'utils/ads',
    'utils/social',
    'utils/tracking',
    'utils/ux',
    'utils/user',
    'legacy_core',
    'console'
], function (
    $,
    jquery_ui_is_global,
    qtip_is_global,
    cookies_is_global,
    inlineEdit_is_global,
    placeholder_is_global,
    migrate_is_jq_plugin,
    Polyfill,
    tos,
    navigation,
    Ads,
    Social,
    Tracking,
    UX,
    mmf_user,
    legacy_core_is_global,
    console
) {
    'use strict';

    /* -----------------------------
    Initialize the CSRF token header
    ----------------------------- */
    var csrfSafeMethod = function (method) {
        // these HTTP methods do not require CSRF protection
        return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
    };

    $.ajaxSetup({
        beforeSend: (function () {
            var csrftoken = $.cookies.get('csrftoken');
            return function (xhr, settings) {
                if (!csrfSafeMethod(settings.type)) {
                    xhr.setRequestHeader("X-CSRFToken", csrftoken);
                }
            };
        })()
    });
    /* -----------
    End CSRF header
    ------------ */

    // DOM dependent
    $(function () {
        console.time('initialize');

        tos.init();

        navigation.init();

        UX.JumptoSavedCity();

        UX.Header.Search.Init();

        UX.Footer.Slider.Init();

        UX.HoverContent();

        UX.List3();

        UX.Slider();

        UX.Tooltip.Init('.tooltip');

        UX.Dialog.Init();

        UX.QTipDialog.Init();

        UX.InlineEdit();

        UX.TableOptions();

        UX.DocumentClose();

        Polyfill.Placeholder();

        UX.Favorite();

        Tracking.Init();

        UX.AjaxContainers.Init();

        UX.Messaging.Init();

        UX.JumpMenu.Init();

        UX.Expandable.Init();

        UX.LazyLoad.Init();

        UX.Touts.Init();

        UX.Header.SubNav.Init();

        Social.Facebook.Init();

        Ads.Init();

        UX.SubmitOnce.init();

        UX.Tabs.Init();
        console.timeEnd('initialize');
    });

});

